import { useQuery } from "@tanstack/react-query";
import {
  EuTaxonomyActivityCategoryDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_EU_TAXONOMY_ACTIVITY } from "../domain";

import { euTaxonomyActivityApi } from "@api/services";
import { TANSTACK_QUERY_STALE_TIME } from "@constants";
import { roleGuard } from "@api";

export const ACTION_GET_ACTIVITY_CATEGORIES = "GET_ACTIVITY_CATEGORIES";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

const getActivityCategories = async (): Promise<EuTaxonomyActivityCategoryDto[]> => {
  const response =
    await euTaxonomyActivityApi.euTaxonomyActivityControllerGetEuTaxonomyActivityCategories();

  return response.data;
};

export const useGetActivityCategories = (
  user: UserProfileDto | null,
): {
  activityCategories?: EuTaxonomyActivityCategoryDto[];
  activitiesEnabled: boolean;
  isSuccessGetActivityCategories: boolean;
  isLoadingGetActivityCategories: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const { data, isLoading, isSuccess } = useQuery({
    queryKey: [DOMAIN_EU_TAXONOMY_ACTIVITY, ACTION_GET_ACTIVITY_CATEGORIES],
    queryFn: () => getActivityCategories(),
    staleTime: TANSTACK_QUERY_STALE_TIME,
  });

  return {
    activityCategories: data,
    activitiesEnabled: enabled,
    isSuccessGetActivityCategories: isSuccess,
    isLoadingGetActivityCategories: isLoading,
  };
};
